import type { AuthContextUser } from 'contexts';
import type { CachedOrg } from '@bb/automaton/src/types/schema';
import { featureEnabled } from './featureFlagBrowserClient';

const isManualCoopUserWithAccess = (
  authUser: AuthContextUser,
  listingOrg?: CachedOrg,
) => {
  if (!featureEnabled('supraManualCoopFeature')) {
    return false;
  }
  if (!listingOrg?.mlsTypes?.length) {
    return false;
  }

  const currentUserManualCoopMlsTypes =
    authUser.supraSubscription?.manualCoopOwnerMlsTypes;
  return listingOrg.mlsTypes.some((mlsType: string) =>
    currentUserManualCoopMlsTypes.includes(mlsType),
  );
};

export default isManualCoopUserWithAccess;
